// ConditionEditor — IF-THEN condition rules (Angel One light theme)
import React from 'react';
import { ALGO_CONDITIONS } from '../../../config/tradingConstants';
import { FaPlus, FaTimes } from 'react-icons/fa';

export default function ConditionEditor({ conditions, onChange }) {
  const addCondition = () => {
    onChange([...conditions, { field: 'ltp', operator: 'is above', value: '' }]);
  };

  const updateCondition = (index, updates) => {
    const newConditions = [...conditions];
    newConditions[index] = { ...newConditions[index], ...updates };
    onChange(newConditions);
  };

  const removeCondition = (index) => {
    onChange(conditions.filter((_, i) => i !== index));
  };

  const fields = [
    { value: 'ltp', label: 'LTP' },
    { value: 'open', label: 'Open' },
    { value: 'high', label: 'High' },
    { value: 'low', label: 'Low' },
    { value: 'close', label: 'Prev Close' },
    { value: 'volume', label: 'Volume' },
  ];

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <label className="text-[11px] font-medium text-gray-500">
          Conditions ({conditions.length})
        </label>
        <button
          onClick={addCondition}
          className="text-xs text-blue-600 hover:text-blue-700 flex items-center gap-1"
        >
          <FaPlus className="text-[8px]" /> Add Condition
        </button>
      </div>

      {conditions.length === 0 && (
        <p className="text-xs text-gray-400 bg-gray-50 rounded-lg px-3 py-2 border border-gray-100">
          No conditions — strategy will trigger on every tick
        </p>
      )}

      <div className="space-y-2">
        {conditions.map((cond, i) => (
          <div key={i} className="flex items-center gap-2 bg-gray-50 rounded-lg px-3 py-2 border border-gray-100">
            <span className="text-[10px] text-gray-400 font-semibold w-6">
              {i === 0 ? 'IF' : 'AND'}
            </span>
            <select
              value={cond.field}
              onChange={e => updateCondition(i, { field: e.target.value })}
              className="bg-white border border-gray-300 rounded-lg px-2 py-1.5 text-[11px] text-gray-900 focus:outline-none focus:ring-1 focus:ring-blue-500"
            >
              {fields.map(f => <option key={f.value} value={f.value}>{f.label}</option>)}
            </select>
            <select
              value={cond.operator}
              onChange={e => updateCondition(i, { operator: e.target.value })}
              className="bg-white border border-gray-300 rounded-lg px-2 py-1.5 text-[11px] text-gray-900 focus:outline-none focus:ring-1 focus:ring-blue-500"
            >
              {ALGO_CONDITIONS.price.map(op => <option key={op} value={op}>{op}</option>)}
            </select>
            <input
              type="number"
              value={cond.value}
              onChange={e => updateCondition(i, { value: e.target.value })}
              placeholder="Value"
              className="w-24 bg-white border border-gray-300 rounded-lg px-2 py-1.5 text-[11px] text-gray-900 font-mono focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
            <button onClick={() => removeCondition(i)} className="p-1 text-gray-400 hover:text-red-500">
              <FaTimes className="text-[9px]" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
